/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-var: 0 */
/* globals _, Backbone, DateRange, mixpanel, mp, RelativeDate */

_.namespace(`mp.marketing.trends`, function(ns) {
  'use strict';

  ns.ReportViewer = Backbone.TemplateView.extend({
    className: `report_viewer`,

    templates: {
      'base': `#data_view`,
      'dropdown_report_item': `#dropdown_report_item`,
      'promo': `#report_promo`,
    },

    initialize() {
      // create a session object for each viewer instance.
      // this is to store session state that is not global but
      // shared between the graph, table, and conversion graph
      ns.session.data = new Backbone.Model();
      ns.session.trigger(`create:data`);

      ns.session.data.on(`change`, this.serialize_params, this);
      ns.session.on(`change:report`, this.load_report, this);

      this.api = new ns.TrendsApi();

      this.on_close(function() {
        // close widgets
        this.date_picker.remove();
        if (this.current_report) { this.current_report.close(); }

        // unbind data
        ns.session.off(null, null, this);

        // clear our session object
        ns.session.data.off();
        ns.session.data = null;

        this.$(`.report_dropdown_arrow`).off(`click`);
        this.$(`.signal-subscribe form`).off(`submit`);
        this.off(null, null, this);
      });

      this.load_report();
      this.render();

      this.on(`ready`, function() {
        this.current_report.trigger(`ready`);
        this._update_stats(ns.session.data, ns.session.data.get(`date_range`));
      }, this);
    },

    render() {
      var slug = ns.session.get(`report`);
      this.render_base_template({slug});
      this.render_date_picker();
      this.$(`.report_render_target`).html(this.current_report.el);
      document.body.scrollTop = document.documentElement.scrollTop = 0;

      var report = _.find(ns.reports, function(r) { return r.slug === slug; });
      this.$(`.report_dropdown_title`).text(report.nice_name);
      this.$(`.report_dropdown_arrow`).on(`click`, function(ev) {
        ev.preventDefault();
        ns.router.goto_report();
      });

      var subscribe_form = this.$(`.signal-subscribe form`);
      subscribe_form.on(`submit`, function(ev) {
        ev.preventDefault();
        var input_el = subscribe_form.find(`input`);
        var email = input_el.val();
        if (subscribe_form.hasClass(`done`) || !email) {
          return;
        }
        input_el.val(``);
        subscribe_form.addClass(`done`).attr(`disabled`, true)
          .find(`button`).text(`Thank you!`);
        setTimeout(function() {
          subscribe_form.removeClass(`done`).attr(`disabled`, false)
            .find(`button`).text(`Subscribe`);
        }, 4000);

        mixpanel.blog.identify(email);
        mixpanel.blog.people.set({'$email': email});
        mixpanel.blog.track(`Blog - Subscribed`, {email});
        mixpanel.track(`Blog - Subscribed`, {email});
      });

      var asterisk_el = this.$(`.report_asterisk`);
      if (this.current_report.asterisk) {
        asterisk_el
          .text(this.current_report.asterisk)
          .toggleClass(`long`, this.current_report.asterisk.length > 50);
      }
      asterisk_el.toggleClass(`empty`, !this.current_report.asterisk);
    },

    render_date_picker() {
      this.date_picker = new mp.widgets.DatePicker().create(
        this.$(`.date_picker`),
        [ ], {
          'min_date': new Date(2013, 1, 5),
        }
      );

      this._update_date_picker();
      this.date_picker.onchange(_.bind(function(date_range) {
        ns.session.data.set(`date_range`, date_range);
      }, this));

      ns.session.data.on(`change:date_range`, this._update_date_picker, this);
      ns.session.data.on(`change:date_range`, this._update_stats, this);
    },

    _update_date_picker() {
      var range = ns.session.data.get(`date_range`);
      if (range) {
        this.date_picker.set_dates(range, true);
      }
    },

    _update_stats(m, date_range) {
      if (!date_range) { return; }

      var params = {
        'query_name': `update_stats`,
        'from_date': date_range.from().toString(mp.utility.default_date_format),
        'to_date': date_range.to().toString(mp.utility.default_date_format),
        'unit': `day`,
      };
      const $dataFooter = this.$(`.data_view_footer`);
      $dataFooter.hide();
      this.api.query(params, _.bind(function(data) {
        if (!data.error) {
          const count = _.reduce(data.data.values.Action, function(acc, c) { return acc + c; }, 0);
          $dataFooter.show().find(`.r_num`).text(_.numberFormat(count, 0));
        }
      }, this));
    },

    load_report() {
      var report_slug = ns.session.get(`report`);
      if (!report_slug) { return; }

      var Report = _.find(ns.reports, function(r) { return r.slug === report_slug; });
      this.time_units = Report.time_units;

      if (this.current_report) { this.current_report.close(); }
      this.current_report = new Report({
        session: ns.session.data,
        api: this.api,
        legend_type: Report.legend_type,
        color_scheme: Report.color_scheme,
        asterisk: Report.asterisk,
      });

      var defaults = this.current_report.get_defaults();
      var resets = _.extend({}, defaults, ns.session.data.attributes);
      ns.session.data.set(resets);

      mixpanel.marketing_trends.track(`Viewed Report`, {'report': report_slug});
      mixpanel.track(`[trends] Viewed Trends Report`, {'report': report_slug});
    },

    update_params(params) {
      if (!_.isUndefined(params.from_date) && !_.isUndefined(params.to_date)) {
        params.date_range = new DateRange(
          new RelativeDate(params.from_date),
          new RelativeDate(params.to_date)
        );
        delete params.from_date; delete params.to_date;
      }

      ns.session.data.set(params);
    },

    serialize_params() {
      var params = {};

      if (ns.session.data.has(`date_range`)) {
        params.from_date = ns.session.data.get(`date_range`).relative_from();
        params.to_date = ns.session.data.get(`date_range`).relative_to();
      }

      if (ns.session.data.has(`report_unit`)) {
        params.report_unit = ns.session.data.get(`report_unit`);
      }

      this.trigger(`serialize_params`, `report/` + ns.session.get(`report`), params);
    },
  });
});

}.call(window));